export const nl = {
  title: 'PRODES (legale Amazon)',
  subtitle: 'jaarlijks, 6,25 ha, Legal Amazon, INPE',
  content: [
    {
      label: 'Functie',
      value:
        'Ontbossingsmonitoringsysteem voor het Braziliaanse legale Amazonegebied, dat door de Braziliaanse overheid wordt gebruikt om openbaar beleid vast te stellen',
    },
    {
      label: 'Resolutie',
      value: '6,25ha',
    },
    {
      label: 'Geografische dekking',
      value: 'Braziliaanse juridische Amazon',
    },
    {
      label: 'Bron',
      value: 'INPE',
    },
    {
      label: 'Frequentie',
      value: 'Jaarlijks',
    },
    {
      label: 'Datum van inhoud',
      value: '2008-2021',
    },
    {
      label: 'Waarschuwingen',
      value:
        'PRODES identificeert alleen boskapgebieden van 6,25 hectare of groter, dus bosdegradatie of kleinere open plekken door brand of selectieve houtkap worden niet gedetecteerd. Frequente bewolking boven gebieden van de dekkingsgebieden kan het gerapporteerde jaar van ontbossing veranderen. Het gerapporteerde jaar is het eerste jaar waarin ontbossing door analisten wordt vastgesteld, maar dit komt niet noodzakelijkerwijs overeen met het jaar van ontbossing als het landschap de afgelopen jaren door wolken is bedekt.',
    },
    {
      label: 'Licentie',
      value: 'Creative Commons DOOR SA 3.0',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'Het PRODES-project monitort de duidelijke ontbossing in het Braziliaanse Amazonegebied en het Cerrado-bioom, en heeft sinds 1988 jaarlijkse ontbossingscijfers voor de regio opgeleverd. De Braziliaanse regering gebruikt deze cijfers om openbaar beleid vast te stellen, waaronder het definiëren van de toegang tot kredieten in het Amazone-bioom, het vaststellen van doelstellingen voor het terugdringen van de ontbossing en het werven van fondsen om de ontbossing terug te dringen. PRODES gebruikte historisch Landsat 5-afbeeldingen, maar bevat nu ook beelden van Landsat 7 en 8, CBERS-2, CBERS-2B, Resourcesat-1 en UK2-DMC. PRODES wordt beheerd door het National Institute of Space Research (INPE) in samenwerking met het Ministerie van Milieu (MMA) en het Braziliaanse Instituut voor Milieu en Hernieuwbare Natuurlijke Hulpbronnen (IBAMA). Sinds 2002 zijn alle PRODES-gegevens online publiekelijk beschikbaar. Invoerafbeeldingen voor elk van de 220 Landsat-voetafdrukken die het Braziliaanse Amazonegebied en Cerrado bestrijken, worden geselecteerd op basis van hun gebrek aan bewolking en hun opnamedatum. Het PRODES-systeem gebruikt het seizoensjaar, beginnend op 1 augustus, om de jaarlijkse ontbossing te berekenen, zodat beelden zo dicht mogelijk bij deze datum worden geselecteerd (doorgaans van juli, augustus en september). Van 2003 tot 2005 gebruikten analisten beeldtransformatie om de componenten van vegetatie, bodem en schaduw te bepalen met behulp van het programma SPRING. Deze componenten zijn gesegmenteerd en geclassificeerd in de klassen bos, niet-bos, ontbossing in het doeljaar, eerdere ontbossing, wolken en water, die vervolgens handmatig door experts worden gecorrigeerd. Vanaf 2005 werd een nieuwe methodiek geïmplementeerd die gebruik maakt van het open source TerraAmazon-platform. Het platform zorgt ervoor dat de PRODES-analyse uniformer is en beelden van verschillende satellieten kan bevatten. Net als voorheen worden de beelden zo wolkenvrij mogelijk geselecteerd. De beelden worden vervolgens gemaskeerd om niet-bosbeheer, eerdere ontbossing en water uit te sluiten op basis van de analyse van het voorgaande jaar. Analisten schetsen vervolgens ontboste polygonen in het intacte bos van het voorgaande jaar. Deze dataset toont de jaarlijkse ontbossing in de periode 2008-2020 in het Nrazilian Legal Amazon.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      "Nationaal Instituut voor Ruimteonderzoek (INPE). 'BEVORDERT ontbossing.' Bereikbaar via Global Forest Watch op [datum]. www.globalforestwatch.org",
  },
};
